


/*************************************** Add into cart and refresh page (Theme buttom)  (add to cart / Delete ) ***************************************/

$(document).ready(function () {
    if (sessionStorage.getItem('pageReloaded') === 'true') {
        $('body').addClass('overflow-hidden'); // Add class to body
        $('cart-drawer.drawer').addClass('animate active'); // Add class to cart drawer
        sessionStorage.removeItem('pageReloaded'); // Remove session item
    }

    $('.product-form__buttons .product-form__submit, .form .quick-add__submit, .drawer__cart-items-wrapper cart-remove-button, .cart-item__quantity-wrapper .quantity-popover-container .cart-quantity .quantity__button ').click(function() {
        // Prevent default behavior if necessary (optional)
        // event.preventDefault(); 

        $('body').addClass('prevent-overflow-hidden'); // Add class to prevent overflow
        $('cart-drawer.drawer').addClass('prevent-active'); // Add class to cart drawer

        setTimeout(function() {
            sessionStorage.setItem('pageReloaded', 'true');
            location.reload();
        }, 1000); // Adjust the delay time as needed
    });
});


function updateCartTotalPrice() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let cartTotal = (cart.total_price / 100).toFixed(2); // Convert to a proper price format
      document.getElementById('cart-total-price').innerText = `${cart.currency} ${cartTotal}`; // Update the price
    });
}

// Listen for cart updates
document.addEventListener('cart:updated', updateCartTotalPrice);

// Call the function on page load to ensure price is up-to-date
updateCartTotalPrice();


document.dispatchEvent(new Event('cart:updated'));


/*************************************** end ***************************************/



/**************************************** MORE PRODUCTS ADD TO CART JS ****************************************/

$(document).ready(function () {
  var totalPrice = 0.0;
  var selectedProducts = [];

  if (sessionStorage.getItem('openCartDrawer') === 'true') {
    $('body').addClass('overflow-hidden');
    $('cart-drawer').addClass('animate active');
    
    sessionStorage.removeItem('openCartDrawer');  // Reset the session storage to prevent it from opening the drawer again after subsequent reloads
  }

  function updateTotalPriceAndSelection(checkbox) {
    var productPrice = parseFloat(checkbox.data('price').replace(/\./g, '').replace(',', '.')); // Convert to valid number format
    var variantId = checkbox.data('id');

    if (checkbox.is(':checked')) {
      totalPrice += productPrice;
      selectedProducts.push(variantId);
    } else {
      totalPrice -= productPrice;
      selectedProducts = selectedProducts.filter(id => id !== variantId); // Remove variant ID from selected products
    }

    $('#total-price').text('€' + totalPrice.toFixed(2).replace('.', ',')); // Format with comma for European currency

    if (selectedProducts.length > 0) {
      $("#add-selected-to-cart").prop('disabled', false);
      $('.inner-btn').removeClass('disable');
    } else {
      $("#add-selected-to-cart").prop('disabled', true);
      $('.inner-btn').addClass('disable');
    }
  }

  $(".pair-with-checkbox").each(function () {
    $(this).prop('checked', true); // Check the checkbox
    updateTotalPriceAndSelection($(this)); // Update the total price and selection
  });

  $(".pair-with-checkbox").change(function () {
    updateTotalPriceAndSelection($(this));
  });

  $("#add-selected-to-cart").click(function (e) {
    e.preventDefault();

    if (selectedProducts.length > 0) {
      var items = { items: [] };

      selectedProducts.forEach(function (variantId) {
        items.items.push({ id: variantId, quantity: 1 }); // Add with quantity 1
      });

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify(items),
        dataType: 'json',
        contentType: 'application/json',
        success: function () {
          sessionStorage.setItem('openCartDrawer', 'true');
          location.reload(); 
        },
        error: function (xhr, status, error) {
          alert('Error adding products to cart. Please try again.');
          console.log(error);
        }
      });
    }
  });
});

/*************************************** end ***************************************/

/******************************************* (pair with) products in the cart drawer ********************************************/

$(document).ready(function () {
  if (sessionStorage.getItem('openCartDrawer') === 'true') {
    $('body').addClass('overflow-hidden');
    $('cart-drawer').addClass('animate active');

    sessionStorage.removeItem('openCartDrawer');
  }

  $(".cart-drawer-product__add-to-cart-button").click(function (e) {
    e.preventDefault();

    var variantId = $(this).data('id');
    var items = { items: [{ id: variantId, quantity: 1 }] };

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify(items),
      dataType: 'json',
      contentType: 'application/json',
      success: function () {
        sessionStorage.setItem('openCartDrawer', 'true');
        location.reload();
      },
      error: function (xhr, status, error) {
        alert('Error adding product to cart. Please try again.');
        console.log(error);
      }
    });
  });
});



$(".cart-drawer-product ul").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev">⟵</button>',
    nextArrow: '<button type="button" class="slick-next">⟶</button>'
});

/******************************************* end ********************************************/


/******************************************* Related product ********************************************/

// setTimeout(function() {
//     $('.related-products .shahzaib-slick-slider.grid').slick({
//         infinite: true,
//         slidesToShow: 4,
//         slidesToScroll: 1,
//         autoplay: false,
//         arrows: true,
//         dots: true,
//         prevArrow: '<button type="button" class="slick-prev">⟵</button>',
//         nextArrow: '<button type="button" class="slick-next">⟶</button>'
//     });
// }, 500);

/******************************************* end ********************************************/


/******************************************* Direct buy now button ********************************************/

document.addEventListener('DOMContentLoaded', function () {
  const directBuyBtn = document.getElementById('direct-buy-btn');
  const variantId = document.querySelector('input.product-variant-id').value;

  directBuyBtn.addEventListener('click', function (e) {
    e.preventDefault();

    if (!variantId) {
      alert('Product is unavailable.');
      return;
    }

    // Add product to cart via Shopify AJAX API
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
      .then(response => response.json())
      .then(data => {
        // Redirect to checkout after adding to cart
        window.location.href = '/checkout';
      })
      .catch(error => {
        console.error('Error:', error);
      });
  });
});

/******************************************* end ********************************************/


/*************************************** discount coupon code ***************************************/

let enteredDiscountCode = '';
  function reloadCart() {
    const targetUrl = '/cart.js';
    fetch(targetUrl, {method: 'GET'}).then(res => {
      return res.json();
    }).then(data => {
      const appliedDiscounts = [];
      console.log(data);
      data.cart_level_discount_applications.forEach((discount) => {
        if(discount.type === 'discount_code') {
          appliedDiscounts.push(discount.title);
        }
      });
      data.items.forEach((item) => {
        item.line_level_discount_allocations.forEach((discount) => {
          if(discount.discount_application.type === 'discount_code') {
            appliedDiscounts.push(discount.discount_application.title);
          }
        });
      });
      console.log(appliedDiscounts);

      if (appliedDiscounts.indexOf(enteredDiscountCode) === -1) {
        const errorElement = document.querySelector('.custom-discount-form p.error');
        errorElement.style.display = 'block';
        errorElement.textContent = 'Enter a valid discount code or gift card';
      } else {
        window.location.reload();
      }
    });
  }
  
  document.querySelector('.submit-discount').addEventListener('click', (e) => {
    const discountcodes = '{{ discount_codes }}'.split(',') ? '{{ discount_codes }}'.split(',') : [];
    const discountCode = document.querySelector('.custom-discount-form input').value.trim();
    document.querySelector('.custom-discount-form p.error').style.display = "none";
    if (discountCode && discountCode.length) {
      if (discountcodes.indexOf(discountCode) === -1) {
        discountcodes.push(discountCode);
        enteredDiscountCode = discountCode;
        const targetUrl = '/checkout?discount=' + discountcodes.join(',');
        fetch(targetUrl, {method: 'GET'}).finally(() => {
          reloadCart();
        });
      } else {
        const errorElement = document.querySelector('.custom-discount-form p.error');
        errorElement.style.display = 'block';
        errorElement.textContent = 'Entered Coupon was applied';
      }      
    } else {
        const errorElement = document.querySelector('.custom-discount-form p.error');
        errorElement.style.display = 'block';
        errorElement.textContent = 'Enter a valid discount code or gift card';
    }
  });

  const codeTags = document.querySelectorAll('.remove-discount');
  codeTags.forEach(function(codeTag) {
    codeTag.addEventListener("click", function() {
      const discountcodes = '{{ discount_codes }}'.split(',') ? '{{ discount_codes }}'.split(',') : [];
      const discountCode = this.dataset.code;

      const remainCodes = discountcodes.filter(function(code) { return code !== discountCode });
      const targetUrl = '/checkout?discount=' + remainCodes.join(',');
      fetch(targetUrl, {method: 'GET'}).finally(() => {
        window.location.reload();
      });
    });
  });

/*************************************** end ***************************************/



/*************************************** FOOTER heading tag become into collapse in mobile view ***************************************/

$(document).ready(function() {
  $(".footer-block:nth-child(2) .footer-block__heading").click(function() {
    $(this).toggleClass("active"); 
    $(this).next(".footer-block:nth-child(2) .footer-block__details-content").slideToggle(); 
  });
});

/*************************************** end ***************************************/


/*************************************** Filter drawer ***************************************/


document.addEventListener("DOMContentLoaded", function() {
    const mobileFacetsDisclosure = document.querySelector(".mobile-facets__disclosure");
    const mobileFacetsDetailsList = document.querySelectorAll(".mobile-facets__details"); // Select all '.mobile-facets__details' elements

    // Function to check if '.mobile-facets__disclosure' has 'menu-opening' and 'open' attributes
    function checkAndToggleOpen() {
        if (mobileFacetsDisclosure.classList.contains('menu-opening') && mobileFacetsDisclosure.hasAttribute('open')) {
            // If both conditions are met, add 'open' attribute to all '.mobile-facets__details' elements
            mobileFacetsDetailsList.forEach(function(detailsElement) {
                detailsElement.setAttribute('open', '');
            });
        } else {
            // Remove 'open' attribute from all '.mobile-facets__details' elements if conditions are not met
            mobileFacetsDetailsList.forEach(function(detailsElement) {
                detailsElement.removeAttribute('open');
            });
        }
    }

    // MutationObserver to watch for changes in class and attributes on '.mobile-facets__disclosure'
    const observer = new MutationObserver(function(mutationsList) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'attributes') {
                checkAndToggleOpen();
            }
        }
    });

    // Start observing the '.mobile-facets__disclosure' element for changes to class and attributes
    observer.observe(mobileFacetsDisclosure, { attributes: true });
});


/*************************************** end ***************************************/
